import { FluxoSelect } from "../fluxo/fluxo-select-model";
import { EtapaSelect } from "../etapa/etapa-select-model";
import { TipoAcaoInatividadeEnum } from "../../enum/tipo-acao-inatividade.enum";

export class CanalInatividadePeriodo {
  id?: number;
  tempoInatividade?: string;
  tipoAcao?: TipoAcaoInatividadeEnum | string;
  mensagem?: string;
  fluxo?: FluxoSelect;
  etapa?: EtapaSelect;
  ativo?: boolean;
}
